import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "luanda-saas",
  founder: "Beatriz Almeida",
  company: "Folha Digital",
  city: "São Paulo",
  country: "Brasil",
  pillar: "fractional",
  outcomeShort: {
    en: "Hit €40k MRR with a fractional CFO",
    fr: "40 k€ MRR atteints avec un CFO temps partagé",
  },
  title: {
    en: "Folha Digital scales past €40k MRR with a fractional CFO",
    fr: "Folha Digital franchit les 40 k€ de MRR avec un CFO à temps partagé",
  },
  subtitle: {
    en: "Cash discipline + a real model unlocked Series A conversations.",
    fr: "Discipline cash + vrai modèle financier ont débloqué les discussions Série A.",
  },
  body: {
    en: {
      context: "Folha Digital was growing 20% MoM but burning aggressively. No financial model, no runway clarity, and three failed VC intros.",
      challenge: "First-time founder with no finance background. Brazilian Real volatility, complex ICMS taxes, and EUR-denominated SaaS costs made forecasting nearly impossible.",
      approach: "We placed a fractional CFO 2 days/week for 6 months. Built a multi-currency model, restructured invoicing in BRL/EUR/USD, and prepared a Series A data room.",
      outcome: "Hit €40k MRR with positive contribution margin. Closed a €1.8M seed extension at a 3× higher valuation than 6 months prior.",
      quote: "Having a CFO 2 days a week was the difference between hoping and knowing.",
      quoteAuthor: "Beatriz Almeida · CEO, Folha Digital",
    },
    fr: {
      context: "Folha Digital croissait à 20 % MoM mais brûlait du cash agressivement. Pas de modèle financier, pas de visibilité runway, et trois intros VC ratées.",
      challenge: "Fondatrice première fois sans background finance. Volatilité du Real brésilien, taxes ICMS complexes, et coûts SaaS en EUR rendaient la prévision quasi impossible.",
      approach: "Nous avons placé un CFO temps partagé 2 jours/semaine pendant 6 mois. Modèle multi-devises construit, facturation restructurée en BRL/EUR/USD, et data room Série A préparée.",
      outcome: "40 k€ MRR atteints avec marge de contribution positive. Extension seed de 1,8 M€ signée à une valorisation 3× supérieure à six mois plus tôt.",
      quote: "Avoir un CFO deux jours par semaine, c'est la différence entre espérer et savoir.",
      quoteAuthor: "Beatriz Almeida · CEO, Folha Digital",
    },
  },
};
export default cs;
